var _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 13,
    transform: "translate(6 7)",
    fill: "none",
    stroke: "#1e274f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 18,
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#1e274f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 18,
    transform: "translate(1 13)",
    fill: "none",
    stroke: "#1e274f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDark);
export default __webpack_public_path__ + "static/media/MenuDark.fbdac5a6.svg";
export { ForwardRef as ReactComponent };